// z-index for the axis date input / lockers. Must stay above the legend
// (Legend.tsx uses z-index: 21) so the date picker and inputs render above it.
export const AXIS_INPUT_Z_INDEX = 22;
